"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signupReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var SignupState_init_1 = require("@/pages/common/states/SignupState.init");
exports.signupReducer = function (state, action) {
    if (state === void 0) { state = SignupState_init_1.defaultSignupState; }
    switch (action.type) {
        case typesafe_actions_1.getType(SignupAction_1.default.setPanelActive): {
            return __assign(__assign({}, state), { isActive: action.payload });
        }
        case typesafe_actions_1.getType(SignupAction_1.default.setPanelDim): {
            return __assign(__assign({}, state), { isDim: action.payload });
        }
        case typesafe_actions_1.getType(SignupAction_1.default.setLoading): {
            return __assign(__assign({}, state), { isLoading: action.payload });
        }
        case typesafe_actions_1.getType(SignupAction_1.default.setGlobalError): {
            if (action.payload) {
                return __assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), { global: action.payload }) });
            }
            return state;
        }
    }
    return state;
};
